const initialState = {
  sportsCommunityBadge: [],
  lastSportsCommunityBadge: [],
};

const SportsCommunityBadgeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SPORTS_COMMUNITY_BADGE":
      return {
        ...state,
        sportsCommunityBadge: action.payload,
      };
    case "SET_LAST_SPORTS_COMMUNITY_BADGE":
      return {
        ...state,
        lastSportsCommunityBadge: action.payload,
      };

    default:
      return state;
  }
};

export default SportsCommunityBadgeReducer;
